import { Layout } from '@/components/Layout';
import { LookupTable } from '../components/LookupTable';
import { lookupsApi } from '../api';

export default function SpeciesPage() {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-8">
        <LookupTable
          title="Especies"
          description="Gestiona las especies de animales disponibles"
          queryKey="species"
          listFn={lookupsApi.listSpecies}
          createFn={lookupsApi.createSpecies}
          updateFn={lookupsApi.updateSpecies}
          deleteFn={lookupsApi.deleteSpecies}
        />
      </div>
    </Layout>
  );
}
